import None from "./Frames/None";
import Black from "./Frames/Black";
import BlackList from "./Frames/BlackList";
import DarkOak from "./Frames/DarkOak";
import LightOak from "./Frames/LightOak";
import LightOakList from "./Frames/LightOakList";
import White from "./Frames/White";
import Bambus from "./Frames/Bambus";
import GoldAlu from "./Frames/GoldAlu";

export default class FrameImagePreloader
{
    /**
     * @returns {void}
     */
    constructor() {
        this.preloadedFrameImages = {};
    }

    /**
     * @param callback
     */
    loadFrameImages(callback) {
        let imagePromises = [];
        FrameImagePreloader.getFrames().forEach((frame, preloadedImagesCount) => {
            imagePromises.push(this.loadImage(frame));
        });
        Promise.all(imagePromises)
            .then(function(images) {
                // All images loaded successfully
                callback();
            })
            .catch(function(error) {
                console.error("Error loading images: ", error);
            });
    }

    loadImage(frame) {
        return new Promise((resolve, reject) => {
            let $frame = jQuery(document).find('#' + frame.id);
            if ($frame.length <= 0) {
                let newFrameImage = new Image();
                newFrameImage.id = frame.id;
                newFrameImage.src = frame.src;
                // WARNING!!! NEVER SET THE LAZY LOAD ATTRIBUTE ON THESE IMAGES!!! Frames won't load as expected!
                newFrameImage.style = 'display:none;';
                this.preloadedFrameImages[frame.image_name] = newFrameImage;
                newFrameImage.onload = () => {
                    resolve(newFrameImage);
                };
                newFrameImage.onerror = (error) => {
                    reject(error);
                };
            }
        });
    }

    /**
     * @returns {*|{}}
     */
    getPreloadedFrameImages() {
        return this.preloadedFrameImages;
    }

    /**
     *
     * @returns {(LightOak|White)[]}
     */
    static getFrames() {
        return [
            new None(),
            new Black(),
            new BlackList(),
            new DarkOak(),
            new LightOak(),
            new LightOakList(),
            new White(),
            new Bambus(),
            new GoldAlu()
        ];
    }
}
